import { Injectable } from '@angular/core';

// Backs ForceReloadRouteReuseStrategy: while active, shouldReuseRoute returns false for every
// route segment in the in-flight navigation, forcing Angular to destroy and recreate components
// instead of reusing them. Ref-counted (not a boolean) so overlapping forced reloads - e.g. an
// account switch that also exits impersonation triggers reloadCurrentRoute() twice - keep it
// active until the last navigation finishes, instead of the first one clearing it early.
@Injectable({
	providedIn: 'root',
})
export class ForceRouteReloadService {
	private activeCount = 0;

	public get isActive(): boolean {
		return this.activeCount > 0;
	}

	public beginForceReload(): void {
		this.activeCount++;
	}

	public endForceReload(): void {
		this.activeCount = Math.max(0, this.activeCount - 1);
	}
}
